/**
 * Created by lourencomarinho on 20/10/14.
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.MultiRoute = function () {

    this.route;
    this.lookupList;

    this.openModal = function (route) {

        this.route = route;

        this.modalForm = new Monet.Form.Modal('#routeMaps_' + this.route.id, null, null, '#routeMaps_' + this.route.id + ' .containerRouteDetail');
        this.modalForm.showModalForm();

        this.createBody();
        this.applyElementsStyle();
        this.populateLookupList();

    };

    this.createBody = function () {

        var routeTabSelector = '#routeMaps_' + this.route.id;
        var modalContainer = document.querySelector(routeTabSelector + ' .popupFormContainer');

        this.appendLookup(modalContainer);
        this.appendSaveButton(modalContainer);

    };

    this.applyElementsStyle = function () {

        var routeTabSelector = '#routeMaps_' + this.route.id;

        var modalContainer = document.querySelector(routeTabSelector + ' .popupFormContainer');
        modalContainer.style.width = '600px';
        modalContainer.style.height = '400px';
        modalContainer.style.marginLeft = '-300px';
        modalContainer.id = 'RouteMapsModal';

        var closeModalWindow = document.querySelector(routeTabSelector + ' .closeModalWindow');
        closeModalWindow.style.marginLeft = '288px';

        var lookupList = document.querySelector(routeTabSelector + ' .popupFormContainer .container_lookuplist_added');
        lookupList.style.width = '400px';

        var lookupLabel = document.querySelector(routeTabSelector + ' .popupFormContainer label');
        lookupLabel.setAttribute('style', 'margin: 5px 10px 0; float: left; position: relative; width: 70px;');

        var lookupListExtraEl = document.querySelector(routeTabSelector + ' .popupFormContainer .lookupList');
        lookupListExtraEl.style.padding = '20px';
        lookupListExtraEl.setAttribute('style', lookupListExtraEl.getAttribute('style') + 'float: left;');
    };

    this.appendLookup = function (container) {

        this.lookupList = new Monet.UI.Fields.PowerLookupList();
        this.lookupList.setNameSpace('EquipementRouteDetail');
        this.lookupList.setDisplayKey('key');
        this.lookupList.setLookUpEntity('Equipment');
        this.lookupList.setTextLabel(Monet.I18n.getResourcesByKey('MultiRoute.Equipment.List'));
        this.changeLookupListRenderFunction();

        container.appendChild(this.lookupList.render());

    };

    this.changeLookupListRenderFunction = function () {
        var principalEquipment = Monet.Session.RouteDetail.screensList[this.route.id].equipment;

        this.lookupList.createItemLookupList = (function (scopePrincipalEquipment, routeId) {

            return function (id, value) {

                var entity = this.lookUpEntity.toLowerCase();
                var idItem = entity + '_' + id;
                var item = document.createElement('div');
                var isPrincipalEquipment = (scopePrincipalEquipment.idOfObject && (scopePrincipalEquipment.idOfObject.toString() === id.toString()));

                item.id = id;
                item.className = 'zebrado item_lookuplist_' + idItem;

                var description = document.createElement('div');
                description.className = 'title_item_added';
                description.innerHTML = value;

                var iconDestroy = document.createElement('div');
                iconDestroy.className = 'del_item_added';

                var link = document.createElement('div');
                link.className = 'table-action-destroylink';
                link.innerHTML = '&nbsp;';

                var divStyle = document.createElement('div');
                divStyle.style.clear = 'both';

                if (!isPrincipalEquipment) {

                    item.appendChild(iconDestroy);

                }

                item.appendChild(description);
                iconDestroy.appendChild(link);
                item.appendChild(divStyle);

                this.divLookupListWrapper.appendChild(item);
                iconDestroy.addEventListener('click', (function (scope, element) {
                    return function () {
                        delete Monet.Session.RouteDetail.screensList[routeId].equipments[element.id];
                        scope.destroyItem(element);
                    };
                })(this, item));
            };

        }(principalEquipment, this.route.id));

    };

    this.appendSaveButton = function (container) {

        var saveButton = document.createElement('input');
        var saveAction = (function (scope) {

            return function () {

                scope.saveListToNamespace(scope.lookupList.getFullValue());

                var map = Monet.Session.RouteDetail.screensList[scope.route.id].map;
                var controller = new Greenmile.RouteDetail.InfoRoute(map, scope.route.id);

                controller.getCoordinatesAndDrawOnMap();

                scope.modalForm.closeModalWindow();

            };

        }(this));

        saveButton.type = 'button';
        saveButton.value = Monet.I18n.getResourcesByKey('FilterEventLogs.btnFilter');
        saveButton.removeEventListener('click', saveAction);
        saveButton.id = 'saveEquipmentRouteDetail';
        saveButton.addEventListener('click', saveAction);

        container.appendChild(saveButton);

    };

    this.saveListToNamespace = function (equipmentsList) {

        this.initCacheNamespace();

        Greenmile.RouteDetail.MultiRouteCache.routes[this.route.id] = Greenmile.RouteDetail.MultiRouteCache.routes[this.route.id] || {};
        Greenmile.RouteDetail.MultiRouteCache.routes[this.route.id].equipmentsList = equipmentsList;

    };

    this.retrieveListFromNamespace = function () {

        this.initCacheNamespace();

        var routesObject = Greenmile.RouteDetail.MultiRouteCache.routes;
        var equipmentList = null;

        if (routesObject) {

            var routeObject = Greenmile.RouteDetail.MultiRouteCache.routes[this.route.id];

            if (routeObject) {

                equipmentList = Greenmile.RouteDetail.MultiRouteCache.routes[this.route.id].equipmentsList;

            }
        }

        return equipmentList;

    };

    this.populateLookupList = function () {

        var equipmentsList = this.retrieveListFromNamespace();

        if (equipmentsList && equipmentsList.length > 0) {

            this.populateLookupWithPreviousEquipmentsLis();

        } else {

            this.populateLookupWithEquipmentAssignments();

        }

    };

    this.populateLookupWithEquipmentAssignments = function () {

        if (this.route.equipmentAssignments) {

            var equipments = this.route.equipmentAssignments.map(function (equipmentAssignment) {

                return new App.Models.Equipment(equipmentAssignment.equipment);

            });

            this.lookupList.setValue(equipments);

        }

    };

    this.populateLookupWithPreviousEquipmentsLis = function () {

        var equipmentsList = this.retrieveListFromNamespace();

        var equipments = equipmentsList.map(function (equipment) {

            return new App.Models.Equipment(equipment);

        });

        this.lookupList.setValue(equipments);

    };

    this.initCacheNamespace = function () {


        Greenmile.RouteDetail = Greenmile.RouteDetail || {};
        Greenmile.RouteDetail.MultiRouteCache = Greenmile.RouteDetail.MultiRouteCache || {};
        Greenmile.RouteDetail.MultiRouteCache.routes = Greenmile.RouteDetail.MultiRouteCache.routes || {};

    };

};
